
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'
import Company from '@/types/company'
import axios from 'axios'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class UserEditDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'users', show: 'userShow', edit: 'userEdit' },
    routeParamKey: 'userId',
    functionNames: { setCurrent: 'setCurrentUser', save: 'saveUser' },
    getterNames: { current: 'currentUser', loading: 'loadingUser', errors: 'userErrors' }
  }

  companies:Company[] = []
  newPassword = false

  mounted () : void {
    this.getCompanies()
  }

  getCompanies () : void {
    axios.get(process.env.VUE_APP_API_URL + '/companies?page=1&limit=5000&sort=name').then((res) => {
      this.companies = res.data.data
    })
  }

  filterCompanies (input:string, option:{componentOptions:{children:{text:string}[]}}) : boolean {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get companyLink () : string {
    if (this.canEditCompany) {
      return `/bedrijf/${this.currentItem.company_id}/bewerken`
    }

    if (this.canViewCompany) {
      return `/bedrijf/${this.currentItem.company_id}/bekijken`
    }

    return ''
  }

  get canViewCompany () : boolean {
    return can('companies.view')
  }

  get canEditCompany () : boolean {
    return can('companies.edit')
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
